import { createElement } from 'react';
import { a_ as TagFilterGroup$1, _ as __assign } from '../../index.esm-5f955dcb.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var TagFilterGroup = function TagFilterGroup(props) {
  return /*#__PURE__*/createElement(TagFilterGroup$1, __assign({}, props));
};
TagFilterGroup.displayName = 'TagFilterGroup';

export { TagFilterGroup };
